<template>
  <div
    class="item-faq"
    id="item-faq"
  >
    <accordion
      ref="accordion"
      class="item-faq__accordion"
      :is-content-html="true"
      id="item-faq-details"
      :name="$t('ads.main.faq.section.name')"
    >
      <div
        slot="content"
      >
        <div
          v-for="(value, index) in updateFaq"
          :key="index"
          class="item-faq__content">
            <span class="item-faq__question">{{ value.question }}</span><br>
            <span class="item-faq__answer">{{ value.answer }}</span>
        </div>
      </div>
    </accordion>
  </div>

</template>

<script>
import productPageStateComputedMixin
  from '../../utilities/vueMixins/productPageStateComputedMixin/productPageStateComputedMixin.js';
import Accordion from '../accordion/accordion.vue';

export default {
  components: {
    Accordion
  },
  mixins: [
    productPageStateComputedMixin
  ],
  props: {
    id: String
  },
  computed: {
    updateFaq() {
      return this.productDetails.itemFaq.faq;
    }
  },
  methods: {
    openAccordion() {
      this.$refs.accordion.open();
    }
  }
};

</script>

